import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { findAll, remove, save } from "./api-cronograma-aula";
import { timeFormat } from "../../../util/DateUtil";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { success } from "../../../util/ToastUtil";
import Container from "../../UI/Container";
import { mensagemDe } from "../cronogramaUtil";
import CronogramaAulaForm from "./CronogramaAulaForm";
import CronogramaAulaTable, { porHorarioInicio } from "./CronogramaAulaTable";

const ordenar = (lista) => [...lista].sort(porHorarioInicio);

const CronogramaAulaContainer = () => {
  const [cronogramasAula, setCronogramasAula] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editando, setEditando] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    findAll()
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(mensagemDe(data));
        } else if (Array.isArray(data)) {
          setCronogramasAula(ordenar(data));
        }
      })
      .finally(() => setIsLoading(false));
  }, []);

  const handleSave = (persist) => {
    const eNovo = !persist.codigo;
    setIsSaving(true);
    save(persist)
      .then((data) => {
        if (!data || data.error) {
          errorMessage(mensagemDe(data, "Não foi possível salvar o horário de aula."));
          return;
        }
        setCronogramasAula((prevState) =>
          ordenar(eNovo ? [...prevState, data] : prevState.map((a) => (a.codigo === data.codigo ? data : a))),
        );
        setEditando(null);
        success("Salvo com sucesso.");
      })
      .finally(() => setIsSaving(false));
  };

  const handleDelete = (aula) => {
    confirmAlert({
      title: "Alerta",
      message: `Deseja remover a ${aula.ordemAula}ª aula (${timeFormat(aula.horarioInicio)} - ${timeFormat(aula.horarioFim)})?`,
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            remove(aula.codigo).then((data) => {
              if (data?.error) {
                errorMessage(mensagemDe(data, "Não foi possível remover o horário de aula."));
                return;
              }
              setCronogramasAula((prevState) => prevState.filter((a) => a.codigo !== aula.codigo));
              success("Horário de aula removido.");
            });
          },
        },
        { label: "Não", onClick: () => {} },
      ],
    });
  };

  return (
    <Container>
      <CronogramaAulaForm
        cronogramaAula={editando}
        onClose={() => setEditando(null)}
        onSave={handleSave}
        isSaving={isSaving}
      />

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
        mb={3}
      >
        <Box>
          <Typography variant="h6">Horários de Aula</Typography>
          <Typography variant="body2" color="text.secondary">
            Horários usados para montar o cronograma das turmas.
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setEditando({ eNovo: true })}>
          Novo Horário
        </Button>
      </Stack>

      <CronogramaAulaTable
        cronogramasAula={cronogramasAula}
        isLoading={isLoading}
        onEdit={setEditando}
        onDelete={handleDelete}
      />
    </Container>
  );
};

export default CronogramaAulaContainer;
